/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type ClientConfigurationDTOConfigKey =
  (typeof ClientConfigurationDTOConfigKey)[keyof typeof ClientConfigurationDTOConfigKey];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientConfigurationDTOConfigKey = {
  PARENT_EMAIL_PROMPT: "PARENT_EMAIL_PROMPT",
  CAMPAIGN_WRITER_EMAIL_SYSTEM_PROMPT: "CAMPAIGN_WRITER_EMAIL_SYSTEM_PROMPT",
  CAMPAIGN_WRITER_EMAIL_APOLLO_SYSTEM_PROMPT: "CAMPAIGN_WRITER_EMAIL_APOLLO_SYSTEM_PROMPT",
  CAMPAIGN_WRITER_EMAIL_BEE_INIT_JSON: "CAMPAIGN_WRITER_EMAIL_BEE_INIT_JSON",
} as const;
